﻿ class NavItem {
    constructor(el, index) {
        this.render(el, index);
    }

    open__CLICK(e) {
        this.menuPanel.addClass('open');
    }

    close__CLICK(e) {
        this.menuPanel.removeClass('open');
    }   

    render(el, index) {
        this.element = $(el);        
        this.openButton = this.element.find('[data-ref="nav-open"]');
        this.closeButton = this.element.find('[data-ref="nav-close"]');
        this.menuPanel = this.element.find('[data-ref="nav-menu"]');

        this.openButton.on('click', this.open__CLICK.bind(this));
        this.closeButton.on('click', this.close__CLICK.bind(this));
    }
}

class Nav {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
 
    render(el, index) {
        new NavItem(el, index);
    }
}

export default Nav;